export default "__VITE_ASSET__DP6bhX4t__"